<template>
  <ProyeksiJabatanForm mode="Ubah" module="Proyeksi Jabatan"> </ProyeksiJabatanForm>
</template>

<script>
import ProyeksiJabatanForm from './form';

const ProyeksiJabatanUpdate = {
  name: 'ProyeksiJabatanUpdate',
  components: { ProyeksiJabatanForm },
};

export default ProyeksiJabatanUpdate;
</script>
